import React, { useEffect, useState } from "react";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import Header from "../Header";
import { useTranslation } from "react-i18next";

export default function Help() {
  const { t } = useTranslation("help");
  const location = useLocation();

  // Section 3 is active when any of its child pages are open
  const section3Active =
    location.pathname.indexOf("/help/ai-endpoint") === 0 ||
    location.pathname === "/help/helprgp";

  // Section 4 is active when any of its child pages are open
  const section4Active =
    location.pathname.indexOf("/help/prompt-profile") === 0 ||
    location.pathname.indexOf("/help/prinput") === 0 ||
    location.pathname.indexOf("/help/dos-profile") === 0 ||
    location.pathname.indexOf("/help/hdosinput") === 0 ||
    location.pathname.indexOf("/help/model-attack-profile") === 0 ||
    location.pathname.indexOf("/help/mcp-profile") === 0 ||
    location.pathname.indexOf("/help/mcpinput") === 0 ||
    location.pathname.indexOf("/help/rto-profile") === 0 ||
    location.pathname.indexOf("/help/hrtosinput") === 0 ||
    location.pathname.indexOf("/help/helprgprofile") === 0 ||
    location.pathname.indexOf("/help/helpreginput") === 0;

  const section7Active =
    location.pathname.indexOf("/help/getallep") === 0 ||
    location.pathname.indexOf("/help/deleteep") === 0 ||
    location.pathname.indexOf("/help/epscript") === 0 ||
    location.pathname.indexOf("/help/cus") === 0 ||
    location.pathname.indexOf("/help/usingParam") === 0 ||
    location.pathname.indexOf("/help/getalltests") === 0 ||
    location.pathname.indexOf("/help/testid") === 0 ||
    location.pathname.indexOf("/help/runtest") === 0 ||
    location.pathname.indexOf("/help/stoptest") === 0 ||
    location.pathname.indexOf("/help/apiCp") === 0 ||
    location.pathname.indexOf("/help/profileByid") === 0 ||
    location.pathname.indexOf("/help/allProfiles") === 0 ||
    location.pathname.indexOf("/help/delprofile") === 0 ||
    location.pathname.indexOf("/help/reportByid") === 0 ||
    location.pathname.indexOf("/help/alltestfiles") === 0 ||
    location.pathname.indexOf("/help/profileconfig") === 0 ||
    location.pathname.indexOf("/help/profileconfigai") === 0 ||
    location.pathname.indexOf("/help/profileconfigmcp") === 0 ||
    location.pathname.indexOf("/help/profileconfigpd") === 0 ||
    location.pathname.indexOf("/help/profileconfigrto") === 0 ||
    location.pathname.indexOf("/help/profileconfigreg") === 0 ||
    location.pathname.indexOf("/help/getsessionkey") === 0 ||
    location.pathname.indexOf("/help/downloadep") === 0 ||
    location.pathname.indexOf("/help/pdfgen") === 0 ||
    location.pathname.indexOf("/help/recapi") === 0;

  const section5Active =
    location.pathname.indexOf("/help/helpgh") === 0 ||
    location.pathname.indexOf("/help/helpgl") === 0 ||
    location.pathname.indexOf("/help/helpHarness") === 0;

  const section6Active =
    location.pathname.indexOf("/help/eppromptDoc") === 0 ||
    location.pathname.indexOf("/help/epvpd") === 0 ||
    location.pathname.indexOf("/help/epmvpd") === 0 ||
    location.pathname.indexOf("/help/eprc") === 0 ||
    location.pathname.indexOf("/help/eprto") === 0 ||
    location.pathname.indexOf("/help/epsdos") === 0 ||
    location.pathname.indexOf("/help/epvdos") === 0 ||
    location.pathname.indexOf("/help/epmvdos") === 0 ||
    location.pathname.indexOf("/help/epsmcp") === 0 ||
    location.pathname.indexOf("/help/epvmcp") === 0 ||
    location.pathname.indexOf("/help/epmvmcp") === 0 ||
    location.pathname.indexOf("/help/llmapi") === 0;

  const [section3Open, setSection3Open] = useState(section3Active);
  const [section4Open, setSection4Open] = useState(section4Active);
  const [section5Open, setSection5Open] = useState(section5Active);
  const [section6Open, setSection6Open] = useState(section6Active);
  const [section7Open, setSection7Open] = useState(section7Active);

  // Automatically open the section containing the current page
  useEffect(() => {
    if (section3Active) {
      setSection3Open(true);
    }

    if (section4Active) {
      setSection4Open(true);
    }

    if (section5Active) {
      setSection5Open(true);
    }

    if (section6Active) {
      setSection6Open(true);
    }
  }, [section3Active, section4Active, section5Active, section6Active]);

  function navClassName({ isActive }) {
    return isActive ? "help-nav-link active" : "help-nav-link";
  }

  function subNavClassName({ isActive }) {
    return isActive ? "help-sub-link active" : "help-sub-link";
  }

  return (
    <div className="theme-dark">
      {/* =====================================================
          INTERNAL CSS - DARK THEME
      ====================================================== */}
      <style>{`
        .help-layout {
          display: flex;
          width: 100%;
          min-height: calc(100vh - 70px);
          background-color: #0f172a;
          color: #f3f4f6;
        }

        .help-navigation {
          width: 330px;
          min-width: 330px;
          height: calc(100vh - 70px);
          overflow-y: auto;
          overflow-x: hidden;
          padding: 20px;
          box-sizing: border-box;
          border-right: 1px solid #1e293b;
          background: #1e293b;
        }

        .help-back {
          display: block;
          margin-bottom: 20px;
          color: #9ca3af;
          font-size: 14px;
          font-weight: 500;
          text-decoration: none;
          transition: color 0.2s ease;
        }

        .help-back:hover {
          color: #60a5fa;
          text-decoration: none;
        }

        .help-navigation-header {
          margin-bottom: 20px;
        }

        .help-navigation-header h1 {
          margin: 0 0 8px 0;
          color: #f9fafb;
          font-size: 21px;
          font-weight: 700;
        }

        .help-navigation-header p {
          margin: 0;
          color: #9ca3af;
          font-size: 13px;
          line-height: 1.5;
        }

        .help-nav {
          width: 100%;
          display: flex;
          flex-direction: column;
          gap: 3px;
        }

        .help-nav-link {
          width: 100%;
          display: flex;
          align-items: center;
          box-sizing: border-box;
          padding: 11px 12px;
          border-radius: 6px;
          color: #d1d5db;
          background: transparent;
          font-size: 14px;
          line-height: 1.4;
          text-decoration: none;
          transition: background-color 0.2s ease, color 0.2s ease;
        }

        .help-nav-link:hover {
          color: #60a5fa;
          background: #334155;
          text-decoration: none;
        }

        .help-nav-link.active {
          color: #60a5fa;
          background: rgba(37, 99, 235, 0.2);
          font-weight: 600;
        }

        .help-collapsible-section {
          width: 100%;
          margin: 0;
          padding: 0;
        }

        .help-collapse-button {
          width: 100%;
          display: flex !important;
          align-items: center;
          justify-content: space-between;
          box-sizing: border-box;
          margin: 0;
          padding: 11px 12px;
          border: 0;
          outline: none;
          border-radius: 6px;
          color: #d1d5db;
          background: transparent;
          font-family: inherit;
          font-size: 14px;
          text-align: left;
          cursor: pointer;
          appearance: none;
          transition: background-color 0.2s ease, color 0.2s ease;
        }

        .collapse-arrow {
          width: 20px;
          height: 20px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          margin-left: 8px;
          color: #9ca3af;
          font-size: 15px;
          transition: transform 0.25s ease;
        }

        .collapse-arrow.open {
          transform: rotate(180deg);
        }

        .help-subsection {
          width: 100%;
          margin: 3px 0 5px 0;
          padding-left: 15px;
          box-sizing: border-box;
          border-left: 1px solid #334155;
        }

        .help-sub-link {
          width: 100%;
          display: block;
          box-sizing: border-box;
          padding: 9px 10px;
          margin: 2px 0;
          border-radius: 5px;
          color: #9ca3af;
          font-size: 13px;
          line-height: 1.4;
          text-decoration: none;
          transition: background-color 0.2s ease, color 0.2s ease;
        }

        .help-sub-link:hover {
          color: #60a5fa;
          background: #334155;
          text-decoration: none;
        }

        .help-sub-link.active {
          color: #60a5fa;
          background: rgba(37, 99, 235, 0.2);
          font-weight: 600;
        }

        .help-nested-subsection {
          width: 100%;
          padding-left: 20px;
          box-sizing: border-box;
        }

        .help-nested-subsection .help-sub-link {
          padding-top: 7px;
          padding-bottom: 7px;
          color: #6b7280;
          font-size: 12px;
        }

        .help-nested-subsection .help-sub-link:hover {
          color: #60a5fa;
        }

        .help-content {
          flex: 1;
          min-width: 0;
          padding: 30px;
          box-sizing: border-box;
          overflow-x: auto;
          background: #0f172a;
          color: #f3f4f6;
        }

        .help-navigation::-webkit-scrollbar {
          width: 6px;
        }

        .help-navigation::-webkit-scrollbar-track {
          background: transparent;
        }

        .help-navigation::-webkit-scrollbar-thumb {
          background: #334155;
          border-radius: 10px;
        }

        .help-navigation::-webkit-scrollbar-thumb:hover {
          background: #475569;
        }

        @media screen and (max-width: 1000px) {
          .help-navigation {
            width: 290px;
            min-width: 290px;
          }

          .help-content {
            padding: 20px;
          }
        }

        @media screen and (max-width: 700px) {
          .help-layout {
            display: block;
          }

          .help-navigation {
            width: 100%;
            min-width: 100%;
            height: auto;
            max-height: 50vh;
            border-right: none;
            border-bottom: 1px solid #1e293b;
          }

          .help-content {
            width: 100%;
            padding: 20px;
          }
        }

        @media screen and (max-width: 480px) {
          .help-navigation {
            padding: 15px;
          }

          .help-navigation-header h1 {
            font-size: 19px;
          }

          .help-nav-link {
            font-size: 13px;
          }

          .help-sub-link {
            font-size: 12px;
          }

          .help-content {
            padding: 15px;
          }
        }
      `}</style>

      {/* Application Header */}
      <Header />

      {/* Help Layout */}
      <div className="help-layout">
        {/* ===================================================
            LEFT HELP NAVIGATION
        ==================================================== */}
        <aside className="help-navigation">
          <Link to="/" className="help-back">
            {t("thelp.backToDashboard")}
          </Link>

          <div className="help-navigation-header">
            <h1>{t("thelp.navigationHeaderTitle")}</h1>
            <p>{t("thelp.navigationHeaderSubtitle")}</p>
          </div>

          <nav className="help-nav">
            {/* 1. LOGIN */}
            <NavLink to="/help/login" className={navClassName}>
              {t("thelp.nav.login")}
            </NavLink>

            {/* 2. HOW TO START */}
            <NavLink to="/help/start" className={navClassName}>
              {t("thelp.nav.howToStart")}
            </NavLink>

            <NavLink to="/help/lic" className={navClassName}>
              {t("thelp.nav.trialLicense")}
            </NavLink>

            {/* =================================================
                3. CREATE ENDPOINT AND PROFILE
            ================================================== */}
            <div className="help-collapsible-section">
              <button
                type="button"
                className={
                  section3Active
                    ? "help-collapse-button parent-active"
                    : "help-collapse-button"
                }
                onClick={() => {
                  setSection3Open(!section3Open);
                }}
              >
                <span>{t("thelp.nav.createEndpointAndProfile")}</span>

                <span
                  className={
                    section3Open ? "collapse-arrow open" : "collapse-arrow"
                  }
                >
                  ▾
                </span>
              </button>

              {section3Open && (
                <div className="help-subsection">
                  <NavLink
                    to="/help/ai-endpoint/overview"
                    className={subNavClassName}
                  >
                    {t("thelp.nav.aiEndpoint")}
                  </NavLink>

                  <NavLink
                    to="/help/ai-endpoint/configure"
                    className={subNavClassName}
                  >
                    {t("thelp.nav.modelEndpoint")}
                  </NavLink>

                  <NavLink
                    to="/help/ai-endpoint/test"
                    className={subNavClassName}
                  >
                    {t("thelp.nav.mcpEndpoint")}
                  </NavLink>

                  <NavLink to="/help/helprgp" className={subNavClassName}>
                    {t("thelp.nav.regulationEndpoint")}
                  </NavLink>
                </div>
              )}
            </div>

            {/* =================================================
                4. CREATE PROFILE
            ================================================== */}
            <div className="help-collapsible-section">
              <button
                type="button"
                className={
                  section4Active
                    ? "help-collapse-button parent-active"
                    : "help-collapse-button"
                }
                onClick={() => {
                  setSection4Open(!section4Open);
                }}
              >
                <span>{t("thelp.nav.createProfile")}</span>

                <span
                  className={
                    section4Open ? "collapse-arrow open" : "collapse-arrow"
                  }
                >
                  ▾
                </span>
              </button>

              {section4Open && (
                <div className="help-subsection">
                  {/* 4.1 */}
                  <NavLink
                    to="/help/prompt-profile"
                    className={subNavClassName}
                  >
                    {t("thelp.nav.promptProfile")}
                  </NavLink>

                  <div className="help-nested-subsection">
                    <NavLink to="/help/prinput" className={subNavClassName}>
                      {t("thelp.nav.promptInputFormat")}
                    </NavLink>
                  </div>

                  {/* 4.2 */}
                  <NavLink to="/help/dos-profile" className={subNavClassName}>
                    {t("thelp.nav.dosProfile")}
                  </NavLink>

                  <div className="help-nested-subsection">
                    <NavLink to="/help/hdosinput" className={subNavClassName}>
                      {t("thelp.nav.dosInputFormat")}
                    </NavLink>
                  </div>

                  {/* 4.3 */}
                  <NavLink
                    to="/help/model-attack-profile"
                    className={subNavClassName}
                  >
                    {t("thelp.nav.modelAttackProfile")}
                  </NavLink>

                  {/* 4.4 */}
                  <NavLink to="/help/mcp-profile" className={subNavClassName}>
                    {t("thelp.nav.mcpProfile")}
                  </NavLink>

                  <div className="help-nested-subsection">
                    <NavLink to="/help/mcpinput" className={subNavClassName}>
                      {t("thelp.nav.mcpInputFormat")}
                    </NavLink>
                  </div>

                  {/* 4.5 */}
                  <NavLink to="/help/rto-profile" className={subNavClassName}>
                    {t("thelp.nav.rtoProfile")}
                  </NavLink>

                  <div className="help-nested-subsection">
                    <NavLink to="/help/hrtosinput" className={subNavClassName}>
                      {t("thelp.nav.rtoInputFormat")}
                    </NavLink>
                  </div>

                  {/* 4.6 */}
                  <NavLink
                    to="/help/helprgprofile"
                    className={subNavClassName}
                  >
                    {t("thelp.nav.regulationProfile")}
                  </NavLink>

                  <div className="help-nested-subsection">
                    <NavLink
                      to="/help/helpreginput"
                      className={subNavClassName}
                    >
                      {t("thelp.nav.regulationInputFormat")}
                    </NavLink>
                  </div>
                </div>
              )}
            </div>

            {/* 5. CREATE MALICIOUS PROMPT/DOCS */}
            <NavLink to="/help/create-prompts-docs" className={navClassName}>
              {t("thelp.nav.createMaliciousPrompts")}
            </NavLink>

            {/* 6. RUNNING SCAN */}
            <NavLink to="/help/scan" className={navClassName}>
              {t("thelp.nav.runningScan")}
            </NavLink>

            {/* 7. ADD USER */}
            <NavLink to="/help/add-users" className={navClassName}>
              {t("thelp.nav.addUser")}
            </NavLink>

            <div className="help-collapsible-section">
              <button
                type="button"
                className={
                  section5Active
                    ? "help-collapse-button parent-active"
                    : "help-collapse-button"
                }
                onClick={() => {
                  setSection6Open(!section6Open);
                }}
              >
                <span>{t("thelp.nav.simulatedEndpoints")}</span>

                <span
                  className={
                    section6Open ? "collapse-arrow open" : "collapse-arrow"
                  }
                >
                  ▾
                </span>
              </button>

              {section6Open && (
                <div className="help-subsection">
                  <NavLink
                    to="/help/eppromptDoc"
                    className={subNavClassName}
                  >
                    {t("thelp.nav.securePromptAndDoc")}
                  </NavLink>
                  <NavLink to="/help/epvpd" className={subNavClassName}>
                    {t("thelp.nav.vulnerablePromptAndDoc")}
                  </NavLink>
                  <NavLink to="/help/epmvpd" className={subNavClassName}>
                    {t("thelp.nav.moderateVulnerablePromptAndDoc")}
                  </NavLink>
                  <NavLink to="/help/eprc" className={subNavClassName}>
                    {t("thelp.nav.regulationCompliance")}
                  </NavLink>
                  <NavLink to="/help/eprto" className={subNavClassName}>
                    {t("thelp.nav.rto")}
                  </NavLink>
                  <NavLink to="/help/epsdos" className={subNavClassName}>
                    {t("thelp.nav.secureDos")}
                  </NavLink>
                  <NavLink to="/help/epvdos" className={subNavClassName}>
                    {t("thelp.nav.vulnerableDos")}
                  </NavLink>
                  <NavLink to="/help/epmvdos" className={subNavClassName}>
                    {t("thelp.nav.moderateVulnerableDos")}
                  </NavLink>
                  <NavLink to="/help/epsmcp" className={subNavClassName}>
                    {t("thelp.nav.secureMcp")}
                  </NavLink>
                  <NavLink to="/help/epvmcp" className={subNavClassName}>
                    {t("thelp.nav.vulnerableMcp")}
                  </NavLink>
                  <NavLink to="/help/epmvmcp" className={subNavClassName}>
                    {t("thelp.nav.moderatelyVulnerableMcp")}
                  </NavLink>
                  <NavLink to="/help/ai-sim-guide" className={subNavClassName}>
                    {t("thelp.nav.llmApiSimulator")}
                  </NavLink>
                </div>
              )}
            </div>

            <div className="help-collapsible-section">
              <button
                type="button"
                className={
                  section5Active
                    ? "help-collapse-button parent-active"
                    : "help-collapse-button"
                }
                onClick={() => {
                  setSection7Open(!section7Open);
                }}
              >
                <span>{t("thelp.nav.restApiInterface")}</span>

                <span
                  className={
                    section7Open ? "collapse-arrow open" : "collapse-arrow"
                  }
                >
                  ▾
                </span>
              </button>

              {section7Open && (
                <div className="help-subsection">
                  <NavLink to="/help/instructions" className={subNavClassName}>
                    {t("thelp.nav.instructions")}
                  </NavLink>
                  <NavLink to="/help/getelement" className={subNavClassName}>
                    {t("thelp.nav.getEndpointById")}
                  </NavLink>
                  <NavLink to="/help/getallep" className={subNavClassName}>
                    {t("thelp.nav.getAllEndpoints")}
                  </NavLink>
                  <NavLink to="/help/deleteep" className={subNavClassName}>
                    {t("thelp.nav.deleteEndpoint")}
                  </NavLink>
                  <NavLink to="/help/epscript" className={subNavClassName}>
                    {t("thelp.nav.createEndpointPython")}
                  </NavLink>
                  <NavLink to="/help/cus" className={subNavClassName}>
                    {t("thelp.nav.createEndpointScripts")}
                  </NavLink>
                  <NavLink to="/help/usingParam" className={subNavClassName}>
                    {t("thelp.nav.createEndpointJson")}
                  </NavLink>
                  <NavLink to="/help/getalltests" className={subNavClassName}>
                    {t("thelp.nav.getAllTests")}
                  </NavLink>
                  <NavLink to="/help/testid" className={subNavClassName}>
                    {t("thelp.nav.getTestStatusById")}
                  </NavLink>
                  <NavLink to="/help/stoptest" className={subNavClassName}>
                    {t("thelp.nav.stopTest")}
                  </NavLink>
                  <NavLink to="/help/apiCp" className={subNavClassName}>
                    {t("thelp.nav.apiCreateProfile")}
                  </NavLink>
                  <NavLink to="/help/profileByid" className={subNavClassName}>
                    {t("thelp.nav.getProfileById")}
                  </NavLink>
                  <NavLink to="/help/allProfiles" className={subNavClassName}>
                    {t("thelp.nav.getAllProfiles")}
                  </NavLink>
                  <NavLink to="/help/delprofile" className={subNavClassName}>
                    {t("thelp.nav.deleteProfile")}
                  </NavLink>
                  <NavLink to="/help/reportByid" className={subNavClassName}>
                    {t("thelp.nav.getReportById")}
                  </NavLink>
                  <NavLink to="/help/alltestfiles" className={subNavClassName}>
                    {t("thelp.nav.getAllTestFiles")}
                  </NavLink>
                  <NavLink
                    to="/help/profileconfig"
                    className={subNavClassName}
                  >
                    {t("thelp.nav.profileConfigAiModel")}
                  </NavLink>
                  <NavLink
                    to="/help/profileconfigai"
                    className={subNavClassName}
                  >
                    {t("thelp.nav.profileConfigDos")}
                  </NavLink>
                  <NavLink
                    to="/help/profileconfigmcp"
                    className={subNavClassName}
                  >
                    {t("thelp.nav.profileConfigMcp")}
                  </NavLink>
                  <NavLink
                    to="/help/profileconfigpd"
                    className={subNavClassName}
                  >
                    {t("thelp.nav.profileConfigPd")}
                  </NavLink>
                  <NavLink
                    to="/help/profileconfigrto"
                    className={subNavClassName}
                  >
                    {t("thelp.nav.profileConfigRto")}
                  </NavLink>
                  <NavLink
                    to="/help/profileconfigreg"
                    className={subNavClassName}
                  >
                    {t("thelp.nav.profileConfigReg")}
                  </NavLink>
                  <NavLink to="/help/getsessionkey" className={subNavClassName}>
                    {t("thelp.nav.getSessionKey")}
                  </NavLink>
                  <NavLink to="/help/downloadep" className={subNavClassName}>
                    {t("thelp.nav.downloadEndpointFiles")}
                  </NavLink>
                  <NavLink to="/help/pdfgen" className={subNavClassName}>
                    {t("thelp.nav.pdfGenerationReport")}
                  </NavLink>
                  <NavLink to="/help/recapi" className={subNavClassName}>
                    {t("thelp.nav.recommendations")}
                  </NavLink>
                </div>
              )}
            </div>

            <NavLink to="/help/llmprofile" className={navClassName}>
              {t("thelp.nav.llmApiProfile")}
            </NavLink>

            <NavLink to="/help/con-reports" className={navClassName}>
              {t("thelp.nav.consolidateReports")}
            </NavLink>

            <div className="help-collapsible-section">
              <button
                type="button"
                className={
                  section5Active
                    ? "help-collapse-button parent-active"
                    : "help-collapse-button"
                }
                onClick={() => {
                  setSection5Open(!section5Open);
                }}
              >
                <span>{t("thelp.nav.cicdGitHubGitLab")}</span>

                <span
                  className={
                    section5Open ? "collapse-arrow open" : "collapse-arrow"
                  }
                >
                  ▾
                </span>
              </button>

              {section5Open && (
                <div className="help-subsection">
                  <NavLink to="/help/helpgh" className={subNavClassName}>
                    {t("thelp.nav.gitHub")}
                  </NavLink>

                  <NavLink to="/help/helpgl" className={subNavClassName}>
                    {t("thelp.nav.gitLab")}
                  </NavLink>

<NavLink to="/help/helpHarness" className={subNavClassName}>
                    {t("thelp.nav.harness")}
                  </NavLink>


                </div>
              )}
            </div>
          </nav>
        </aside>

        {/* ===================================================
            RIGHT CONTENT
        ==================================================== */}
        <main className="help-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}